module.exports = __webpack_public_path__ + "static/Logo_0-4aa1422e9b99511635e60f6df6329f4f.png";